import app from '../../app';
import { KeyValueGambit } from '../IGambit';
export default class DiscussionGambit extends KeyValueGambit {
  key() {
    return app.translator.trans('core.lib.gambits.posts.discussion.key', {}, true);
  }
  hint() {
    return app.translator.trans('core.lib.gambits.posts.discussion.hint', {}, true);
  }
  filterKey() {
    return 'discussion';
  }
}
flarum.reg.add('core', 'common/query/discussions/DiscussionGambit', DiscussionGambit);